/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated by: scripts/generate-template-loaders.js
 * Source files:
 *   - classic.njk
 *   - classic.css
 */

export const CLASSIC_TEMPLATE = `{% if isA4 %}
  <div
    class="a4-container">
    <!-- Header Row (50/50 Split) -->
    <div class="a4-hdr-row">
      <div class="a4-hdr-left">
        {% if logoUrl %}
          <img class="a4-hdr-logo-img" src="{{ logoUrl }}" alt="{{ storeName }}"/>
        {% endif %}
      </div>
      <div class="a4-hdr-right-store">
        <div class="store-title">{{ storeName }}</div>
        {% if address %}
          <p>{{ address | replace('\\n', ', ') }}</p>
        {% endif %}
        {% if phone %}
          <p>{{ phone }}
            {% if whatsapp %}
              / {{ whatsapp }}
            {% endif %}
          </p>
        {% endif %}
        {% if email %}
          <p>{{ email }}</p>
        {% endif %}
        {% if website %}
          <p>{{ website }}</p>
        {% endif %}
      </div>
    </div>
    <!-- Horizontal Metadata Row -->
    <div class="a4-meta-row">
      <div class="a4-meta-col">
        <span class="a4-meta-lbl">Return No</span>
        <strong class="a4-meta-val">{{ orderNo }}</strong>
      </div>
      {% if originalOrderNo %}
        <div class="a4-meta-col">
          <span class="a4-meta-lbl">Orig Inv No</span>
          <strong class="a4-meta-val">{{ originalOrderNo }}</strong>
        </div>
      {% endif %}
      <div class="a4-meta-col">
        <span class="a4-meta-lbl">Date / Time</span>
        <strong class="a4-meta-val">{{ dateStr }} - {{ timeStr }}</strong>
      </div>
      <div class="a4-meta-col">
        <span class="a4-meta-lbl">Cashier</span>
        <strong class="a4-meta-val">{{ cashier or "-" }}</strong>
      </div>
      <div class="a4-meta-col text-right">
        <span class="a4-meta-lbl">Type</span>
        <span class="status-badge-a4 return" style="font-weight: bold;">{{ orderStatus or "RETURN" }}</span>
      </div>
    </div>
    <!-- Customer Cards Info -->
    <div class="a4-cust-card">
      <div class="a4-cust-grid">
        <span class="a4-cust-lbl">Customer Name:</span>
        <span class="a4-cust-val">{{ customerName }}</span>
        {% if customerAddress %}
          <span class="a4-cust-lbl">Address:</span>
          <span class="a4-cust-val">{{ customerAddress }}</span>
        {% endif %}
        {% if customerPhone %}
          <span class="a4-cust-lbl">Contact:</span>
          <span class="a4-cust-val">{{ customerPhone }}</span>
        {% endif %}
        {% if customerEmail %}
          <span class="a4-cust-lbl">Email:</span>
          <span class="a4-cust-val" style="text-transform: none;">{{ customerEmail }}</span>
        {% endif %}
      </div>
    </div>
    <!-- Optional Return Reason / Notes -->
    {% if orderNote %}
      <div style="margin: 12px 0 14px 0; background: #f8f9fa; border: 1px solid #dee2e6; border-left: 4px solid #343a40; padding:
          10px 12px; font-size: 12px; color: #212529; line-height: 1.5;">
        <strong style="font-size: 10px; letter-spacing: 1px; text-transform: uppercase; display: block; margin-bottom: 4px; color:
            #212529;">
          Return Reason / Notes</strong>
        {{ orderNote }}
      </div>
    {% endif %}
    <!-- Returned Items Table -->
    <table class="a4-items-table">
      <thead>
        <tr>
          <th class="a4-col-no">NO</th>
          <th class="a4-col-desc">RETURNED ITEM DESCRIPTION</th>
          <th class="a4-col-price">REFUND PRICE</th>
          <th class="a4-col-qty">QUANTITY</th>
          <th class="a4-col-amount">REFUND VALUE</th>
        </tr>
      </thead>
      <tbody>
        {% set itemIndex = 1 %}
        {% for item in productItems %}
          <tr class="a4-item-row">
            <td class="a4-col-no">{{ itemIndex }}</td>
            <td class="a4-desc-cell">
              {{ item.product_name or "Product" }}
              {% if item.sku_code %}
                <small>({{ item.sku_code }})</small>
              {% endif %}
              {% if item.batch_no %}
                <small>[{{ item.batch_no }}]</small>
              {% endif %}
            </td>
            <td class="a4-price-cell">{{ item.price | formatPrice }}</td>
            <td class="a4-qty-cell">{{ item.quantity }}</td>
            <td class="a4-amount-cell">{{ item.total_price | formatPrice }}</td>
          </tr>
          {% set itemIndex = itemIndex + 1 %}
        {% endfor %}
      </tbody>
    </table>
    <!-- Modern Summary Section -->
    <div class="a4-summary-container">
      <div class="a4-summary-left-card">
        <div class="a4-info-row">
          <span class="a4-info-label">Total Items Returned</span>
          <span class="a4-info-value">{{ totalItemsCount }} Item(s)</span>
        </div>
        <div class="a4-info-row">
          <span class="a4-info-label">Refund Type</span>
          <span class="a4-info-value status-badge-a4 return">{{ orderStatus or "RETURN" }}</span>
        </div>
        {% if refundMethodName %}
          <div class="a4-info-row">
            <span class="a4-info-label">Refund Method</span>
            <span class="a4-info-value payment-badge">{{ refundMethodName }}</span>
          </div>
        {% endif %}
      </div>
      <div class="a4-summary-right-totals">
        <div class="a4-total-row">
          <span class="a4-total-lbl">Sub Total</span>
          <span class="a4-total-val">{{ productSubtotal | formatPrice }}</span>
        </div>
        <div class="a4-grand-total-row" style="background: #f8f9fa; border-color: #dee2e6;">
          <span class="a4-grand-lbl" style="color: #212529;">TOTAL REFUNDED</span>
          <span class="a4-grand-val" style="color: #212529;">{{ currency }}
            {{ grandTotal | formatPrice }}</span>
        </div>
        {% if cashBalanceAmount > 0 or storeCreditAmount > 0 %}
          <div style="border-top: 1px dashed #dee2e6; margin-top: 5px; padding-top: 5px;"></div>
          {% if cashBalanceAmount > 0 %}
            <div class="a4-total-row" style="font-weight: 600;">
              <span class="a4-total-lbl">Cash Paid Out</span>
              <span class="a4-total-val">{{ currency }}
                {{ cashBalanceAmount | formatPrice }}</span>
            </div>
          {% endif %}
          {% if storeCreditAmount > 0 %}
            <div class="a4-total-row" style="font-weight: 700; color: #212529;">
              <span class="a4-total-lbl">Store Credit Issued</span>
              <span class="a4-total-val">{{ currency }}
                {{ storeCreditAmount | formatPrice }}</span>
            </div>
          {% endif %}
        {% endif %}
      </div>
    </div>
    <!-- Signature Section -->
    <div class="a4-signature-section">
      <div class="a4-sig-block">
        <div class="a4-sig-line"></div>
        <div class="a4-sig-label">Customer Signature</div>
      </div>
      <div class="a4-sig-block">
        <div class="a4-sig-line"></div>
        <div class="a4-sig-label">Authorized Signature</div>
      </div>
    </div>
    <!-- Bottom Footer -->
    <div class="a4-ftr">
      <div class="a4-ftr-thank">Thank you for shopping with us!</div>
      <div class="a4-ftr-powered">Powered by TaproPOS</div>
    </div>
  </div>
{% else %}
  <div class="wrap">
    <div class="status-badge" style="color: #c92a2a; border: 1px solid #c92a2a; padding: 2px; border-radius: 4px;">
      {{ orderStatus or "ORDER RETURN" }}
    </div>
    <div class="hdr">
      {% if logoUrl %}
        <div><img class="hdr-logo" src="{{ logoUrl }}" alt="{{ storeName }}"/></div>
      {% endif %}
      <div class="store-name">{{ storeName }}</div>
      {% if address %}
        <p>{{ address | replace('\\n', ', ') }}</p>
      {% endif %}
      {% if phone %}
        <p>{{ phone }}
          {% if whatsapp %}
            <span>/ {{ whatsapp }}</span>
          {% endif %}
        </p>
      {% endif %}
    </div>
    <hr class="hdr-divider"/>
    <table class="meta-table">
      <tbody>
        <tr>
          <td class="meta-lbl">Return No:</td>
          <td class="meta-val">{{ orderNo }}</td>
        </tr>
        {% if originalOrderNo %}
          <tr>
            <td class="meta-lbl">Orig Inv:</td>
            <td class="meta-val">{{ originalOrderNo }}</td>
          </tr>
        {% endif %}
        <tr>
          <td class="meta-lbl">Return Date</td>
          <td class="meta-val">{{ dateStr }}</td>
        </tr>
        <tr>
          <td class="meta-lbl">Return Time</td>
          <td class="meta-val">{{ timeStr }}</td>
        </tr>
        <tr>
          <td class="meta-lbl">Cashier:</td>
          <td class="meta-val">{{ cashier }}</td>
        </tr>
        <tr>
          <td class="meta-lbl">Customer:</td>
          <td class="meta-val">{{ customerName }}</td>
        </tr>
        {% if customerPhone %}
          <tr>
            <td class="meta-lbl">Contact:</td>
            <td class="meta-val">{{ customerPhone }}</td>
          </tr>
        {% endif %}
      </tbody>
    </table>
    <hr class="meta-divider"/>
    <table class="items-table">
      <thead>
        <tr>
          <th class="col-item">Returned Item</th>
          <th class="col-price">Refund</th>
          <th class="col-qty">Qty</th>
          <th class="col-val">Value</th>
        </tr>
      </thead>
      <tbody>
        {% for item in productItems %}
          <tr class="item-name-row">
            <td class="item-name-cell" colspan="4">
              <span class="item-num">{{ loop.index }}.</span>
              {{ item.product_name or "Product" }} <br/>
              {% if item.batch_no %}
                <small style="color: #666;">[{{ item.batch_no }}]</small>
              {% endif %}
            </td>
          </tr>
          <tr class="item-val-row">
            <td></td>
            <td class="item-price-cell">{{ item.price | formatPrice }}</td>
            <td class="item-qty-cell">X {{ item.quantity }}</td>
            <td class="item-val-cell">{{ item.total_price | formatPrice }}</td>
          </tr>
        {% endfor %}
      </tbody>
    </table>
    <hr class="meta-divider"/>
    <div class="summary">
      <div class="row">
        <span>Total Items</span>
        <span>{{ totalItemsCount }}</span>
      </div>
      <div class="row">
        <span>Refund Type</span>
        <span>{{ orderStatus or "RETURN" }}</span>
      </div>
      {% if refundMethodName %}
        <div class="row">
          <span>Refund Method</span>
          <span>{{ refundMethodName }}</span>
        </div>
      {% endif %}
      <div class="row grand" style="border-color: #000; color: #000;">
        <span>TOTAL REFUNDED</span>
        <span>{{ currency }}
          {{ grandTotal | formatPrice }}</span>
      </div>
      {% if cashBalanceAmount > 0 or storeCreditAmount > 0 %}
        <hr class="dashes"/>
        {% if cashBalanceAmount > 0 %}
          <div class="row" style="font-weight: 600;">
            <span>Cash Paid Out</span>
            <span>{{ currency }}
              {{ cashBalanceAmount | formatPrice }}</span>
          </div>
        {% endif %}
        {% if storeCreditAmount > 0 %}
          <div class="row" style="font-weight: 700; color: #000;">
            <span>Store Credit Issued</span>
            <span>{{ currency }}
              {{ storeCreditAmount | formatPrice }}</span>
          </div>
        {% endif %}
      {% endif %}
    </div>
    {% if orderNote %}
      <div style="margin-top: 10px; font-size: 0.82em; border-left: 2px solid #000; padding-left: 6px; color: #555;">
        <strong>Note:</strong>
        {{ orderNote }}
      </div>
    {% endif %}
    <div class="ftr">
      {% if footer %}
        <p>{{ footer }}</p>
      {% endif %}
      <p style="margin-top:4px;font-size:0.85em">Powered by TaproPOS</p>
    </div>
  </div>
{% endif %}`;

export const CLASSIC_CSS = `@import url("https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;600;700&display=swap");

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: "Courier New", Courier, monospace;
  font-size: var(--inv-font, 12px);
  color: #000;
  background: #fff;
  padding: var(--inv-body-pad, 0);
  line-height: 1.4;
}

.wrap {
  width: var(--inv-width, 210mm);
  max-width: 100%;
  margin: 0 auto;
  background: #fff;
  padding: var(--inv-pad, 8mm 10mm);
}

/* ── Status badge ──────────────────────────────────────── */
.status-badge {
  text-align: center;
  font-size: 0.95em;
  font-weight: 700;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
  text-transform: uppercase;
}

/* ── Header ────────────────────────────────────────────── */
.hdr {
  text-align: center;
  margin-bottom: 4px;
}

.hdr-logo {
  display: block;
  max-height: 64px;
  max-width: 160px;
  object-fit: contain;
  margin: 0 auto 2px;
}

.store-name {
  font-size: var(--inv-h2-size, 1.2em);
  font-weight: 700;
  letter-spacing: 0.2px;
}

.hdr p {
  font-size: 0.88em;
  line-height: 1.4;
}

.hdr-divider {
  border: none;
  border-top: 2px solid #000;
  margin: 4px 0;
}

/* ── Meta table ────────────────────────────────────────── */
.meta-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.88em;
  margin-bottom: 2px;
}

.meta-table td {
  padding: 1.5px 0;
  vertical-align: top;
  line-height: 1.2;
}

.meta-table td.meta-lbl {
  font-weight: 400;
  width: 42%;
  white-space: nowrap;
}

.meta-table td.meta-val {
  font-weight: 700;
  text-align: right;
}

.meta-divider {
  border: none;
  border-top: 1px dashed #000;
  margin: 4px 0;
}

/* ── Items table ───────────────────────────────────────── */
.items-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.88em;
  margin: 0;
}

.items-table thead tr {
  background: #fff;
}

.items-table thead th {
  padding: 4px 4px;
  font-weight: 700;
  border-bottom: 1px dashed #000;
  border-top: 1px dashed #000;
  white-space: nowrap;
}

.items-table thead th.col-item {
  text-align: left;
}
.items-table thead th.col-price {
  text-align: right;
}
.items-table thead th.col-qty {
  text-align: center;
}
.items-table thead th.col-val {
  text-align: right;
}

/* Two-row item layout */
.items-table tr.item-name-row td {
  padding: 0 4px 0 4px;
  font-weight: 400;
  vertical-align: top;
}

.items-table tr.item-val-row td {
  padding: 0 4px 4px 4px;
  border-bottom: 1px dashed #ccc;
  vertical-align: top;
}

.items-table tr.item-disc-row td {
  padding: 0 4px 4px 4px;
  font-size: 0.82em;
  color: #555;
}

.items-table tr.item-disc-row td {
  border-bottom: 1px dashed #ccc;
}

.item-disc-label {
  text-align: right;
  font-style: italic;
}

.item-disc-val {
  text-align: right;
  font-style: italic;
}

.items-table tr.item-val-row:last-child td,
.items-table tr.item-val-row.no-border td {
  border-bottom: none;
}

.item-num {
  font-weight: 400;
  margin-right: 2px;
}

.item-name-cell {
  text-align: left;
}

.item-price-cell {
  text-align: right;
}
.item-qty-cell {
  text-align: center;
}
.item-val-cell {
  text-align: right;
}

/* ── Section separator ─────────────────────────────────── */
.section-header {
  text-align: center;
  font-weight: 700;
  font-size: 0.85em;
  letter-spacing: 0.5px;
  padding: 4px 0;
  border-top: 1px dashed #000;
  border-bottom: 1px dashed #000;
  text-transform: uppercase;
  margin: 2px 0;
}

/* ── Section total row ─────────────────────────────────── */
.section-total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 700;
  font-size: 0.9em;
  padding: 3px 4px;
  border-top: 1px dashed #000;
}

/* ── Summary rows ──────────────────────────────────────── */
.summary {
  margin-top: 2px;
  font-size: 0.88em;
}

.row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 4px;
  gap: 8px;
}

.row.grand {
  font-weight: 700;
  font-size: var(--inv-grand-size, 1em);
  border-top: 2px solid #000;
  border-bottom: 2px solid #000;
  padding: 4px 4px;
  margin-top: 2px;
}

.row.paid {
  font-weight: 600;
}
.row.due {
  font-weight: 600;
}

.dashes {
  border-top: 1px dashed #000;
  margin: 3px 0;
}

/* ── Payment section ───────────────────────────────────── */
.pay-section {
  margin: 4px 0;
  font-size: 0.88em;
}

.pay-section h4 {
  font-weight: 700;
  font-size: 0.82em;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}

/* ── Footer ────────────────────────────────────────────── */
.ftr {
  text-align: center;
  margin-top: var(--inv-ftr-mt, 10px);
  border-top: 1px solid #000;
  padding-top: 5px;
  font-size: var(--inv-ftr-size, 0.82em);
  line-height: 1.5;
}

.ftr p + p {
  margin-top: 2px;
}

@media print {
  body {
    background: #fff;
    padding: 0;
  }
  .wrap {
    box-shadow: none;
    border-radius: 0;
    width: 100% !important;
  }
  @page {
    size: var(--inv-page-size, A4) var(--inv-orientation, portrait);
    margin: 2mm;
  }
}

/* ── A4 Invoice Layout Styles ────────────────────────── */
.a4-container {
  display: flex;
  flex-direction: column;
  font-family: Arial, Helvetica, sans-serif;
  font-size: var(--inv-font, 13px);
  color: #000;
  background: #fff;
  width: 100%;
}

.a4-hdr-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.a4-hdr-left {
  width: 50%;
  flex: 0 0 50%;
}

.a4-hdr-logo-img {
  max-height: 80px;
  max-width: 100%;
  object-fit: contain;
}

.a4-hdr-right-store {
  width: 50%;
  flex: 0 0 50%;
  text-align: right;
}

.a4-hdr-right-store .store-title {
  font-size: 1.5em;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.a4-hdr-right-store p {
  font-size: 0.9em;
  margin: 2px 0;
  color: #333;
}

.a4-meta-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1.5px solid #000;
  border-bottom: 1.5px solid #000;
  padding: 8px 10px;
  margin-bottom: 20px;
  background-color: #f8f9fa;
  font-size: 0.9em;
}

.a4-meta-col {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.a4-meta-col.text-right {
  align-items: flex-end;
}

.a4-meta-lbl {
  font-size: 0.78em;
  text-transform: uppercase;
  color: #555;
  letter-spacing: 0.5px;
}

.a4-meta-val {
  font-size: 0.95em;
  color: #000;
}

.a4-cust-card {
  margin: 10px 0 20px 0;
  font-size: 0.95em;
}

.a4-cust-grid {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 4px 10px;
}

.a4-cust-lbl {
  font-weight: 500;
  color: #333;
}

.a4-cust-val {
  font-weight: 700;
  text-transform: uppercase;
}

.a4-items-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 0.95em;
}

.a4-items-table th,
.a4-items-table td {
  border: 1px solid #888;
  padding: 8px 10px;
}

.a4-items-table th {
  background-color: #f2f2f2;
  font-weight: 700;
  text-transform: uppercase;
}

.a4-col-no {
  width: 6%;
  text-align: center;
}
.a4-col-desc {
  width: 54%;
  text-align: left;
}
.a4-col-price {
  width: 14%;
  text-align: right;
}
.a4-col-qty {
  width: 10%;
  text-align: center;
}
.a4-col-amount {
  width: 16%;
  text-align: right;
}

.a4-item-row td {
  vertical-align: middle;
}

.a4-item-row .a4-desc-cell {
  text-align: left;
}

.a4-item-row .a4-price-cell {
  text-align: right;
}

.a4-item-row .a4-qty-cell {
  text-align: center;
}

.a4-item-row .a4-amount-cell {
  text-align: right;
  font-weight: 500;
}

.a4-item-disc-row td {
  padding: 4px 10px;
  font-size: 0.88em;
  background-color: #fafafa;
}

.a4-item-disc-label {
  text-align: right;
  font-style: italic;
}

.a4-item-disc-val {
  text-align: right;
  font-style: italic;
}

/* ── Modern Summary Section ── */
.a4-summary-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;
  gap: 30px;
}

.a4-summary-left-card {
  width: 45%;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  padding: 15px;
}

.a4-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 8px;
  margin-bottom: 8px;
}

.a4-info-row:last-child {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
}

.a4-info-label {
  color: #495057;
  font-weight: 500;
  font-size: 0.9em;
}

.a4-info-value {
  font-weight: 700;
  color: #212529;
  font-size: 0.9em;
}

.payment-badge {
  text-transform: uppercase;
  background-color: #e9ecef;
  padding: 2px 8px;
  border-radius: 4px;
}

.status-badge-a4 {
  padding: 3px 10px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 0.85em;
  text-transform: uppercase;
}

.status-badge-a4.ordered,
.status-badge-a4.paid,
.status-badge-a4.fully_paid {
  background-color: #e9ecef;
  color: #212529;
}

.status-badge-a4.unpaid,
.status-badge-a4.overdue {
  background-color: #e9ecef;
  color: #212529;
}

.status-badge-a4.partially_paid {
  background-color: #e9ecef;
  color: #212529;
}

.a4-summary-right-totals {
  width: 45%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: right;
}

.a4-total-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.95em;
  color: #495057;
}

.a4-exch-src {
  font-style: italic;
  font-size: 0.8em;
  color: #868e96;
  font-weight: 400;
}

.a4-grand-total-row {
  display: flex;
  justify-content: space-between;
  border-top: 2px solid #212529;
  padding-top: 10px;
  margin-top: 5px;
}

.a4-grand-lbl {
  font-weight: 700;
  font-size: 1.15em;
  color: #212529;
}

.a4-grand-val {
  font-weight: 700;
  font-size: 1.15em;
  color: #212529;
}

/* ── Payments Section ── */
.a4-payments-section {
  margin-top: 25px;
}

.a4-sec-title {
  font-size: 1.05em;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 12px;
  border-bottom: 2px solid #dee2e6;
  padding-bottom: 6px;
  color: #212529;
}

.a4-payments-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  margin-bottom: 20px;
}

.a4-payments-table th {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  padding: 8px 12px;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.85em;
  color: #495057;
  text-align: left;
}

.a4-payments-table td {
  border: 1px solid #dee2e6;
  padding: 10px 12px;
  vertical-align: top;
  font-size: 0.9em;
  color: #212529;
}

.a4-payments-table tr:nth-child(even) td {
  background-color: #fcfcfc;
}

.a4-signature-section {
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
  margin-bottom: 20px;
  padding: 0 15px;
}

.a4-sig-block {
  width: 220px;
  text-align: center;
}

.a4-sig-line {
  border-top: 1px solid #333;
  margin-bottom: 6px;
}

.a4-sig-label {
  font-size: 0.85em;
  font-weight: 600;
  color: #495057;
}

.a4-ftr {
  text-align: center;
  margin-top: 40px;
  font-size: 0.9em;
  line-height: 1.5;
}

.a4-ftr-note {
  font-style: italic;
  margin-bottom: 6px;
}

.a4-ftr-thank {
  font-weight: 700;
  font-size: 1.05em;
}

.a4-ftr-powered {
  margin-top: 8px;
  font-size: 0.8em;
  color: #777;
}

.qr80-ref {
  font-size: 0.72em;
  color: #555;
}
`;
